module.exports = __webpack_public_path__ + "static/media/11.9a0e2278.jpg";